import ApiService from '@/common/api.services'

import {
    SUBSCRIBE,
    UNSUBSCRIBE,
    FETCH_BANNER,
    CONTACTUS,
    CLAIMREFUND,
    SYSTEM_CONFIG,
    NEWS_HEADLINES,
    FETCH_CATEGORY_PROMOTIONAL,
    FETCH_PRODUCT_PROMOTIONS,
    FETCH_NEW_ITEM_CAROUSEL,
    FETCH_SITE_CONTENT,
    FETCH_SEARCH_QUERY,
} from './actions.type'
import {
    SET_BANNER,
    SET_SYSTEM_CONFIG,
    SET_CATEGORY_PROMOTIONAL,
    SET_PRODUCT_PROMOTIONS,
    SET_NEW_ITEM_CAROUSEL,
    SET_SITE_CONTENT,
    SET_SEARCH_QUERY,
} from './mutations.type'

const state = {
    singleBanner: "",
    splitBanner: "",
    homeLeftBanner: "",
    homeRightBanner: "",
    carouselVerticleBanner: "",
    carouselSquareBanner: "",
    systemConfig: "",
    categoryPromotionals: [],
    productPromotions: [],
    newItemCarousels: [],

    siteContent: [],
    searchQuery: []

}

const getters = {
    siteContent(state) {
        return state.siteContent
    },
    categoryPromotionals(state) {
        return state.categoryPromotionals
    },
    newItemCarousels(state) {
        return state.newItemCarousels
    },
    productPromotions(state) {
        return state.productPromotions
    },
    singleBanner(state) {
        return state.singleBanner
    },
    splitBanner(state) {
        return state.splitBanner
    },
    homeLeftBanner(state) {
        return state.homeLeftBanner
    },
    homeRightBanner(state) {
        return state.homeRightBanner
    },
    carouselVerticleBanner(state) {
        return state.carouselVerticleBanner
    },
    carouselSquareBanner(state) {
        return state.carouselSquareBanner
    },
    systemConfig(state) {
        return state.systemConfig
    },
    searchQuery(state) {
        return state.searchQuery
    }
}

const actions = {
    // Query for home new search 

    [FETCH_SEARCH_QUERY](context, query) {
        return ApiService.getWithParams('/search', { params: query })
            .then((response) => {
                context.commit(SET_SEARCH_QUERY, response.data.response.data)
                return response.data.response.data
            })
            .catch((error) => {
                console.log(error)
            })
        },
        [FETCH_SITE_CONTENT](context, query) {
            return ApiService.getWithParams('/sitecontent', query)
            .then((response) => {
                context.commit(SET_SITE_CONTENT, response.data.response.data)
                return response.data.response.data
            })
            .catch((error) => {
                console.log(error)
            })
    },

    [FETCH_PRODUCT_PROMOTIONS](context) {
        return ApiService.getWithParams('/product-promotions', { params: { skip: 0, limit: 50 } })
            .then((response) => {
                context.commit(SET_PRODUCT_PROMOTIONS, response.data.response.data)
                return response.data.response.data
            })
            .catch((error) => {
                console.log("apiResponse data", error)
            })
    },
    [FETCH_NEW_ITEM_CAROUSEL](context) {
        return ApiService.getWithParams('/new-items', { params: { skip: 0, limit: 50 } })
            .then((response) => {
                context.commit(SET_NEW_ITEM_CAROUSEL, response.data.response.data)
                return response.data.response.data
            })
            .catch((error) => {
                console.log("apiResponse data", error)
            })
    },
    [FETCH_CATEGORY_PROMOTIONAL](context) {
        return ApiService.getWithParams('/category-promotions', { params: { skip: 0, limit: 50 } })
            .then((response) => {
                context.commit(SET_CATEGORY_PROMOTIONAL, response.data.response.data)
                return response.data.response.data
            })
            .catch((error) => {
                console.log("apiResponse data", error)
            })
    },
    [SUBSCRIBE](context, subscriber) {

        return ApiService
            .post('subscribe', subscriber)
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                return error.response.status
            })
    },


    [UNSUBSCRIBE](context, subscriber) {
        return ApiService
            .get('unSubscribe', subscriber)
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                return error.response.status
            })
    },

    [SYSTEM_CONFIG](context, subscriber) {
        return ApiService
            .get('system-pricings')
            .then((response) => {
                context.commit(SET_SYSTEM_CONFIG, response.data.data)
                return response.data.data
            })
            .catch(error => {
                return error.response.status
            })
    },
    [NEWS_HEADLINES](context, subscriber) {
        return ApiService
            .get('getNewsHeadlines')
            .then((response) => {
                return response.data.data
            })
            .catch(error => {
                return error.response.status
            })
    },

    [FETCH_BANNER](context, resource) {

        return ApiService
            .get('getAdvertisements/placement', resource)
            .then((response) => {
                context.commit(SET_BANNER, response.data.data[0])
                return response.data
            })
            .catch(error => {
                return error.response.status
            })
    },
    [CONTACTUS](context, resource) {
        return ApiService
            .post('sendContactQuery', resource)
            .then((response) => {
                return response.data
            })
            .catch(error => {
                return error.response.status
            })
    },
    [CLAIMREFUND](context, resource) {
        return ApiService
            .post('claim-refund', resource)
            .then((response) => {
                return response.data
            })
            .catch(error => {
                return error.response.status
            })
    },
}


const mutations = {

    //  set search query result 
    [SET_SEARCH_QUERY](state, response) {
        state.searchQuery = response
    },

    [SET_SITE_CONTENT](state, response) {

        let temp = {};
        if (response.length) {
            for (var i in response) {
                temp[response[i].slug] = response[i]
            }
        }

        state.siteContent = temp
    },
    [SET_PRODUCT_PROMOTIONS](state, response) {
        state.productPromotions = response
    },
    [SET_NEW_ITEM_CAROUSEL](state, response) {
        state.newItemCarousels = response
    },
    [SET_CATEGORY_PROMOTIONAL](state, response) {
        state.categoryPromotionals = response
    },
    [SET_SYSTEM_CONFIG](state, response) {
        state.systemConfig = response
    },
    [SET_BANNER](state, response) {

        if (response) {
            if (response.placement == 'homepageHorizontalSplitBanners') {
                state.splitBanner = response.banners
            }
            if (response.placement == 'homepageLeftSideBanners') {
                state.homeLeftBanner = response.banners
            }
            if (response.placement == 'homepageRightSideBanners') {
                state.homeRightBanner = response.banners
            }
            if (response.placement == 'listingPageHorizontalSingleBanner') {
                state.singleBanner = response.banners
            }
            if (response.placement == 'sidebarVerticalBannerCarousel') {
                state.carouselVerticleBanner = response
            }
            if (response.placement == 'sidebarSquareBannerCarousel') {
                state.carouselSquareBanner = response
            }
        }
    }
}

export default {
    state,
    actions,
    mutations,
    getters
}
